import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icons, type IconName } from './icons.ts'

/**
 * The only place FontAwesome is rendered.
 *
 * Screens name an icon by role -- `<Icon name="undecided" />` -- so swapping the
 * free set for Pro cannot reach past this ingredient. See `icons.ts`.
 */
export function Icon({
  name,
  className,
  spin,
}: {
  name: IconName
  className?: string
  spin?: boolean
}) {
  return <FontAwesomeIcon icon={icons[name]} className={className} spin={spin} aria-hidden />
}
